const watchForEmptyDeclineComments = () => $('#decline-recommendation').on('click', function(e) {
  if ($('#recommendation-text-area').val().trim() === "") {
    e.preventDefault();
    $('#decline-help').removeClass('hidden');
  }
});

$(document).on('turbolinks:load', () => watchForEmptyDeclineComments());
